import Textarea from './component'

export default Textarea
